import React from "react";
import BigNumber from "bignumber.js";
import { Text, View } from "@/styles/reactnative";
import { COLORS } from "../../../../../../constants";

const PriceHigh = ({ indexPrice, info24H }) => {
  const rateColor = info24H?.rate > 0
    ? COLORS.lightGreen
    : info24H?.rate < 0
    ? COLORS.lightRed
    : "#888";

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          fontSize: 14,
          fontWeight: 600,
          letterSpacing: -0.3,
          marginBottom: 2,
        }}
      >
        {BigNumber(indexPrice).toFormat(2)}
      </Text>
      <Text
        style={{
          fontSize: 12,
          fontWeight: 500,
          color: rateColor,
        }}
      >
        {info24H?.rate ? (info24H?.rate > 0 ? '+' : '') + BigNumber(info24H?.rate).toFormat(2) + "%" : '-'}
      </Text>
    </View>
  );
};

export default React.memo(PriceHigh);
